import React from "react";
import Cta from "../../Shared/Cta";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import {
  classOptions,
  genderOptions,
  sectionOption,
  subjectOptions,
} from "../../utils/helpers";
import CustomSelect from "../../Shared/CustomSelect";
import CustomInput from "../../Shared/CustomInput";
import SubmitForm from "../../Shared/SubmitForm";
const AddnewClasses = () => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  const onSubmit = (data) => {
    console.log("submitting data ", data);
  };
  return (
    <>
      <div class="breadcrumbs-area">
        <h3>Classes</h3>
        <ul>
          <li>
            <Link to="/admin">Home</Link>
          </li>
          <li>Add New Class</li>
        </ul>
      </div>

      <div class="card height-auto">
        <div class="card-body">
          <div class="heading-layout1">
            <div class="item-title">
              <h3>Add New Class Schedule</h3>
            </div>
            <Cta />
          </div>
          <form class="new-added-form" onSubmit={handleSubmit(onSubmit)}>
            <div class="row">
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomInput
                  label={"Teacher Name *"}
                  register={register}
                  errors={errors}
                  name={"teacher"}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomInput
                  label={"ID NO *"}
                  register={register}
                  errors={errors}
                  name={"name"}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomSelect
                  label={"Gender *"}
                  register={register}
                  errors={errors}
                  name={"gender"}
                  placeholder={"Please Select Gender"}
                  option={genderOptions}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomSelect
                  label={"Subject Class *"}
                  register={register}
                  errors={errors}
                  name={"subject"}
                  placeholder={"Select Subject"}
                  option={classOptions}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomSelect
                  label={"Subject *"}
                  register={register}
                  errors={errors}
                  name={"subject"}
                  placeholder={"Please Select Subject"}
                  option={subjectOptions}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomSelect
                  label={"Section *"}
                  register={register}
                  errors={errors}
                  name={"section"}
                  placeholder={"Please Select Section"}
                  option={sectionOption}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomInput
                  label={"Time *"}
                  register={register}
                  errors={errors}
                  name={"time"}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <label>Date*</label>
                <input
                  type="text"
                  placeholder="dd/mm/yyyy"
                  class="form-control air-datepicker"
                  data-position="bottom right"
                  {...register("date", {
                    required: "Date is required",
                    validate: (value) =>
                      value.trim() !== "" || "spaces not allowed",
                  })}
                />
                <i class="far fa-calendar-alt"></i>
                {errors.date && (
                  <p style={{ color: "red" }}>{errors.date.message}</p>
                )}
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomInput
                  label={"Phone NO *"}
                  register={register}
                  errors={errors}
                  name={"phone"}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomInput
                  label={"Emial *"}
                  register={register}
                  errors={errors}
                  name={"email"}
                />
              </div>
              <SubmitForm />
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddnewClasses;
